// src/components/Gatoodle/GatoodleTab.jsx
// Tab "El Gatoodle" auf der Projektseite von "El Gato Muerto" (US-GATO-001/002).
// Nur für das Projekt mit Slug "025-el-gato-muerto" eingeblendet (siehe
// ProjectPageWrapper.jsx). Hält den Suchbegriff und den aktiven Subtab
// (Personen/Termine, Muster: die Projekt-Subtabs wie "Controlling").
import React, { useState } from "react";
import GatoodleGaeste from "./GatoodleGaeste.jsx";
import GatoodleTermine from "./GatoodleTermine.jsx";
import "../../styles/gatoodle.scss";

const SUB_TABS = [
  { id: "personen", label: "Personen" },
  { id: "termine", label: "Termine" },
];

const GatoodleTab = ({ readOnly = false }) => {
  const [activeSubTab, setActiveSubTab] = useState("personen");
  const [search, setSearch] = useState("");

  return (
    <div className="gatoodle">
      <h2 className="gatoodle__title">El Gatoodle</h2>

      <div className="gatoodle__toolbar">
        <input
          type="search"
          className="gatoodle__search"
          placeholder="Nach Namen suchen..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          aria-label="Nach Namen suchen"
        />
      </div>

      <div className="gatoodle__subtabs" role="tablist">
        {SUB_TABS.map((tab) => (
          <button
            key={tab.id}
            type="button"
            role="tab"
            aria-selected={activeSubTab === tab.id}
            className={`gatoodle__subtab ${
              activeSubTab === tab.id ? "gatoodle__subtab--active" : ""
            }`}
            onClick={() => setActiveSubTab(tab.id)}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {activeSubTab === "personen" && (
        <GatoodleGaeste readOnly={readOnly} search={search} />
      )}
      {activeSubTab === "termine" && (
        <GatoodleTermine readOnly={readOnly} search={search} />
      )}
    </div>
  );
};

export default GatoodleTab;
